// extracted by mini-css-extract-plugin
export default {"errorContainer":"Launcher_errorContainer__wVqLv","errorContainerButtons":"Launcher_errorContainerButtons__oYPa-"};